import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  openCookiePreferences(event) {
    event.preventDefault()
    const rgpdElement = document.querySelector('[data-controller*="rgpd-consent"]')
    if (rgpdElement) {
      const rgpdController = this.application.getControllerForElementAndIdentifier(rgpdElement, "rgpd-consent")
      if (rgpdController) rgpdController.revokeConsent()
    }
  }

  navigateObfuscated(event) {
    event.preventDefault()
    const encoded = event.currentTarget.dataset.url
    if (encoded) {
      window.location.href = atob(encoded)
    }
  }
}
